import { render, staticRenderFns } from "./ProductEan.vue?vue&type=template&id=fa029e14&scoped=true"
import script from "./ProductEan.vue?vue&type=script&lang=js"
export * from "./ProductEan.vue?vue&type=script&lang=js"
import style0 from "./ProductEan.vue?vue&type=style&index=0&id=fa029e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa029e14",
  null
  
)

export default component.exports